import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import ExecucaoPlano from "components/qualidade/ExecucaoPlano";
import MarcaVeiculo from 'model/gestao/frotas/MarcaVeiculo';
import ExecucaoPlanoQualidade from "model/qualidade/ExecucaoPlanoQualidade";
import ItemNotaFiscalEntrada from "model/suprimentos/ItemNotaFiscalEntrada";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import RecebimentoService from "service/qualidade/RecebimentoService";

const recebimentoService = new RecebimentoService();

export default function RecebimentoCadastro() {

    const [queryParameters] = useSearchParams();

    const [itemNotaEntrada, setItemNotaEntrada] = useState<ItemNotaFiscalEntrada>(new ItemNotaFiscalEntrada());
    const [titulo, setTitulo] = useState<string>('Inspeção de Recebimento');

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();


    function validar() {
        return true;
    }

    return (

        <BaseCadastro model={itemNotaEntrada} service={recebimentoService} setModel={(value: ItemNotaFiscalEntrada) => setItemNotaEntrada(value)} validar={() => validar()} urlService="/recebimento" pathCadastro="/recebimento" tituloPagina={'Recebimento'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 12 }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex", flexDirection: "column", marginBottom: 12 }}>
                <label style={{ fontWeight: 700 }}>Produto</label>
                <div style={{ display: "flex" }}>
                    <InputText style={{ width: "20%", marginRight: 10 }} value={itemNotaEntrada.produto?.codigo || ''} disabled />
                    <InputText style={{ width: "30%" }} value={itemNotaEntrada.produto?.nome || ''} disabled />
                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", marginBottom: 12 }}>
                <label style={{ fontWeight: 700 }}>Lote</label>
                <InputText style={{ width: "20%" }} value={itemNotaEntrada.lote || ''} disabled />
            </div>

            <div style={{ display: "flex", flexDirection: "column", marginBottom: 12 }}>
                <label style={{ fontWeight: 700 }}>Quantidade</label>
                <InputText style={{ width: "20%" }} value={itemNotaEntrada.quantidade+"" || ''} disabled />
            </div>

            <ExecucaoPlano value={itemNotaEntrada.execucaoPlanoQualidade || new ExecucaoPlanoQualidade()} onChange={(value) => { setItemNotaEntrada({ ...itemNotaEntrada, execucaoPlanoQualidade: value }) }} editable={true} />

        </BaseCadastro>
    )
}
